import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LevantamientoObra } from '../models/entities/levantamiento-obra';

@Injectable({
  providedIn: 'root'
})
export class InteraccionMapaService {

  private datosObra: BehaviorSubject<LevantamientoObra> = new BehaviorSubject<LevantamientoObra>(null);
  constructor() { }

  public inicializarDatosObra(): void {
    //Inicializ los datos de la conversación seleccionada
    this.datosObra = new BehaviorSubject<LevantamientoObra>(null);
  }

  public establecerDatosObra(datosObra: LevantamientoObra) {
    this.datosObra = new BehaviorSubject<LevantamientoObra>(datosObra);
  }

  public obtenerDatosObra(): Observable<LevantamientoObra> {
    return this.datosObra.asObservable();
  }

}
